module.exports = __webpack_public_path__ + "img/v1.8fe5c44c.png";